import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { UploaderOptions, UploadInput, UploadFile, humanizeBytes, UploadOutput } from "ngx-uploader";
import { ConfigService } from "../../../../../services/configService";
import { Cookie } from "ng2-cookies";
import { Order } from "../../../../../objects/orders/order";
import { UploadService } from "../../../../../services/uploadService";
import { BaseResponse } from "../../../../../objects/common/baseResponse";
import { OrderContent } from "../../../../../objects/orders/orderContent";
import { OrderDataType } from "../../../../../objects/orders/orderDataType";
import { OrderStatus } from "../../../../../objects/orders/orderStatus";
import * as ps from "perfect-scrollbar";
import { ToastsManager } from "ng2-toastr";
import { BsDropdownDirective, ModalDirective } from "ngx-bootstrap";
import { OrderContentData } from "../../../../../objects/orders/orderContentData";
import { UploadDocument } from "../../../../../objects/documnets/uploadDocumnet";
import { OrderContentService } from "../../../../../services/orderContentService";
import { CBP3461 } from "../../../../../objects/documents/CBP3461";
import { DocumentService } from "../../../../../services/documentService";
import { Document3461Component } from "../../../../export-documents/cbp-3461/document-3461.component";
import { CBP7501 } from "../../../../../objects/documents/CBP7501";
import { Document7501Component } from "../../../../export-documents/cbp-7501/document-7501.component";
import { DatePipe } from "@angular/common";

@Component({
    selector: 'advanced-doc-selector',
    templateUrl: 'advancedDocSelector.component.html',
    moduleId: module.id.toString()
})
export class AdvancedDocSelectorComponent {
    @Input()
    public order: Order;

    @Input()
    public tabNumber: number;

    @Input()
    public documents3461: Array<CBP3461> = [];
    @Input()
    public documents7501: Array<CBP7501> = [];

    @Output()
    public completeOrderEvent: EventEmitter<boolean> = new EventEmitter();

    public orderStatus = OrderStatus;

    public docs: Array<UploadDocument> = [];

    @ViewChild('docSelector') docSelectorRef: ElementRef;

    @ViewChild('dropdownRef') public dropdownDirective: BsDropdownDirective;

    @ViewChild('doc3461Modal') public doc3461ModalDir: Document3461Component;
    @ViewChild(Document7501Component) public doc7501ModalDir: Document7501Component;

    /*file uploader options start*/
    public options: UploaderOptions;
    public files: UploadFile[];
    public humanizeBytes: Function;
    public uploadInput: EventEmitter<UploadInput> = new EventEmitter<UploadInput>();
    public dragOver: boolean;
    public isFileUploading: boolean = false;

    /*file uploader options end*/

    public orderDataType = OrderDataType;

    constructor(public configService: ConfigService,
                public uploadService: UploadService,
                public toastrService: ToastsManager,
                public contentService: OrderContentService,
                private documentService: DocumentService) {
        this.files = []; // local uploading files array
        this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
        this.humanizeBytes = humanizeBytes;

    }

    public ngOnInit(): void {
        this.getDocs();
        ps.initialize(this.docSelectorRef.nativeElement);
    }

    public ngOnChanges(): void {
        this.getDocs();

    }

    public get isSelectAll(): boolean {
        if (this.docs.length == 0)
            return false;

        const result = this.docs.find(x => x.IsSelected == false);

        return result == null;
    }

    public set isSelectAll(value: boolean) {
        const isSelectAll = this.isSelectAll;

        this.docs.forEach(x => x.IsSelected = !isSelectAll);
    }

    public get IsAnySelect(): boolean {
        if (this.docs == null)
            return false;

        return this.docs.find(x => x.IsSelected == true) != null;
    }

    private getCustomDocs(): void {
        if (this.documents3461 != null) {
            this.documents3461.forEach((document: CBP3461) => {
                this.docs.push(this.getUploadDocumentObject(document.Name, document.Created, document.Id, OrderDataType.CPB3461));
            });
        }

        if (this.documents7501 != null) {
            this.documents7501.forEach((document: CBP7501) => {
                this.docs.push(this.getUploadDocumentObject(document.Name, document.Created, document.Id, OrderDataType.CPB7501));
            });
        }
    }

    private getUploadDocumentObject(name: string, date: Date, id: string, type: OrderDataType): UploadDocument {
        let datePipe = new DatePipe("en-US");
        let createdDate = datePipe.transform(date, 'dd/MM/yyyy');

        return new UploadDocument({
            Data: new OrderContent({
                Data: new OrderContentData({
                        Data: `${name}_${createdDate}`,
                        Type: type,
                        Status: 1 // TODO
                    },
                ),
                Id: id
            }),
            IsSelected: false,
        })
    }

    private getDocs(): void {
        this.docs = [];
        for (let orderData of this.order.DataList) {
            if (orderData.Data.Type != OrderDataType.Comment && (orderData.OrderStatus == this.tabNumber))
                this.docs.push(new UploadDocument({
                    Data: orderData,
                    IsSelected: false,
                }));
        }

        this.getCustomDocs();
    }

    public startUpload(): void {
        if (this.files.length == 0 || !this.files[0].name || this.files[0].size > 4000000)
            return;

        this.files = this.files.filter((file: UploadFile) => file.size <= 4000000);

        this.isFileUploading = true;

        let cookie = Cookie.get(this.configService.config.ApiTokenCookieName);

        const event: UploadInput = {
            type: 'uploadFile',
            url: `${this.configService.config.ApiUrl}/upload?orderId=${this.order.Id}&orderstatus=${this.order.Status}`,
            method: 'POST',
            fieldName: "file",
            file: this.files[0],
            data: { 'name': this.files[0].name },
            headers: { Authorization: `Bearer ` + cookie }
        };

        this.files = [];

        this.uploadInput.emit(event);
    }

    public onUploadOutput(output: UploadOutput): void {
        if (output.type === 'allAddedToQueue') {
            this.startUpload();
        } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') { // add file to array when added
            if (output.file.size > 4000000) {
                this.toastrService.error('size must be less than 4 mb', null, { preventDuplicates: true });
                this.files = [];
            }
            else
                this.files.push(output.file);
        } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
            // update current data in files array for uploading file
            const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
            this.files[index] = output.file;
        } else if (output.type === 'removed') {
            // remove file from array when removed
            this.files = this.files.filter((file: UploadFile) => file !== output.file);
        } else if (output.type === 'dragOver') {
            this.dragOver = true;
        } else if (output.type === 'dragOut') {
            this.dragOver = false;
        } else if (output.type === 'drop') {
            this.dragOver = false;
        }
        else if (output.type == "done")
            this.handleUploaded(output.file.response as (BaseResponse<OrderContent>));
    }

    public handleUploaded(response: BaseResponse<OrderContent>): void {
        this.isFileUploading = false;

        if (!response.Data)
            return;

        if (response.Data.OrderStatus == this.tabNumber)
            this.docs.push(new UploadDocument({
                Data: response.Data,
                IsSelected: false,
            }));

        this.order.DataList.push(response.Data)
    }

    public downloadSelectedFiles(): void {
        const docsToDownload = this.docs.filter(d => d.IsSelected == true);

        for (let doc of docsToDownload.filter(d => d.Data.Data.Type == OrderDataType.File)) {
            this.uploadService.downloadFile(doc.Data.Data.Data);
        }

        for (let cbp3461 of docsToDownload.filter(d => d.Data.Data.Type == OrderDataType.CPB3461)) {
            this.uploadService.downloadDocument(cbp3461.Data.Id, 'CBP3461');
        }

        for (let cbp3461 of docsToDownload.filter(d => d.Data.Data.Type == OrderDataType.CPB7501)) {
            this.uploadService.downloadDocument(cbp3461.Data.Id, 'CBP7501');
        }
    }

    public delete(uploadDocument: UploadDocument): void {
        const index = this.docs.indexOf(uploadDocument);

        this.docs.splice(index, 1);

        if (uploadDocument.Data.Data.Type == OrderDataType.File)
            this.contentService.deleteByIds([uploadDocument.Data.Id]).then((x) => {
                this.order.DataList.forEach(document => {

                    if (document.Id == uploadDocument.Data.Id) {
                        const index = this.order.DataList.indexOf(document);
                        if (index >= 0)
                            this.order.DataList.splice(index, 1);
                    }

                });
            });
        else {
            let type: 'CBP3461' | 'CBP7501' = 'CBP3461';

            if (uploadDocument.Data.Data.Type == OrderDataType.CPB7501)
                type = 'CBP7501';

            this.documentService.deleteDocumentById(uploadDocument.Data.Id, type).then((x) => {
                if (uploadDocument.Data.Data.Type == OrderDataType.CPB7501)
                    this.removeFromArray(this.documents7501, uploadDocument.Data.Id);
                else
                    this.removeFromArray(this.documents3461, uploadDocument.Data.Id);
            });
        }
    }

    private removeFromArray(array: Array<CBP7501 | CBP3461>, id: string): void {
        let doc = array.find(x => x.Id == id);

        const index = array.indexOf(doc);

        array.splice(index, 1);
    }

    public showDocument(doc: UploadDocument): void {
        if (doc.Data.Data.Type == OrderDataType.CPB3461) {
            this.documentService.getDocumentById<CBP3461>(doc.Data.Id, 'CBP3461').then((x) => {
                this.doc3461ModalDir.show(x.Data);
            });

            return;
        }

        if (doc.Data.Data.Type == OrderDataType.CPB7501) {
            this.documentService.getDocumentById<CBP7501>(doc.Data.Id, 'CBP7501').then((x) => {
                this.doc7501ModalDir.show(x.Data);
            });

            return;
        }
    }

    public handleDocModified(doc: any): void {
        if (this.documents3461.find(x => x.Id == doc.Data.Id))
            return;

        let type = OrderDataType.CPB3461;

        this.docs.push(this.getUploadDocumentObject(doc.Data.Name, doc.Data.Created, doc.Data.Id, type));
        this.documents3461.push(doc.Data);
    }

    public handleDoc7501Modified(doc: any): void {
        if (this.documents7501.find(x => x.Id == doc.Data.Id))
            return;

        let type = OrderDataType.CPB7501;

        this.docs.push(this.getUploadDocumentObject(doc.Data.Name, doc.Data.Created, doc.Data.Id, type));
        this.documents7501.push(doc.Data);
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderData/tabs/advancedDocSelector.component.ts